import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../layouts/AppLayout';
import ProtectedRoute from '../routes/ProtectedRoute';
import RoleRoute from '../routes/RoleRoute';
import Spinner from '../components/Spinner';

const DashboardPage = lazy(
  () => import('../features/dashboard/components/DashboardPage'),
);
const ProjectDetailPage = lazy(
  () => import('../features/projects/components/ProjectDetailPage'),
);
const ProjectActivityPage = lazy(
  () => import('../features/projects/components/ProjectActivityPage'),
);
const PhaseDetailPage = lazy(
  () => import('../features/checklist/components/PhaseDetailPage'),
);
const AdminPage = lazy(() => import('../features/admin/components/AdminPage'));
const NotFoundPage = lazy(() => import('../components/NotFoundPage'));
const AuthErrorPage = lazy(() => import('../components/AuthErrorPage'));

export default function AppRouter() {
  return (
    <Suspense fallback={<Spinner fullPage />}>
      <Routes>
        {/* Authenticated app shell */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
          <Route
            path="/projects/:projectId/activity"
            element={<ProjectActivityPage />}
          />
          <Route
            path="/projects/:projectId/phases/:phase"
            element={<PhaseDetailPage />}
          />
          <Route
            path="/admin"
            element={
              <RoleRoute requireAdmin>
                <AdminPage />
              </RoleRoute>
            }
          />
        </Route>

        {/* Must stay OUTSIDE ProtectedRoute or unauthenticated users loop back here. */}
        <Route path="/auth-error" element={<AuthErrorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
